"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _ExperimentTreatmentSelectors = require("pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors");

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var NoWrapLink = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "Mon138CalculatorLink__NoWrapLink",
  componentId: "sc-1yq4a4p-0"
})(["white-space:nowrap;"]);

var Mon138CalculatorLink = function Mon138CalculatorLink() {
  var showAnchor = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon138HasAnchorSelector);
  if (!showAnchor) return null;

  var handleClick = function handleClick() {
    document.querySelector('#calculator').scrollIntoView({
      behavior: 'smooth'
    });
    (0, _getUsageTracker.default)().track('scrollInteraction', {
      name: 'hub-subtitle',
      action: 'clicked calculate your price'
    });
  };

  return _react.default.createElement(NoWrapLink, {
    className: "m-left-2",
    onClick: handleClick
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "mon138.calculateYourPrice"
  }), _react.default.createElement(_UIIcon.default, {
    name: "next",
    size: "small",
    className: "m-left-1",
    style: {
      transform: 'rotate(90deg)',
      color: _colors.CALYPSO_DARK
    }
  }));
};

var _default = Mon138CalculatorLink;
exports.default = _default;
module.exports = exports.default;